export const MODEL_FAMILIES = ['claude', 'gpt', 'gemini', 'grok', 'auto', 'other', 'unknown'] as const
export type ModelFamily = (typeof MODEL_FAMILIES)[number]

// Raw model ids are free-form, so metrics only carry the vendor family.
export function modelFamily(modelId: string | undefined): ModelFamily {
  const id = modelId?.trim().toLowerCase()
  if (!id) return 'unknown'
  if (id === 'auto') return 'auto'
  if (id.startsWith('claude')) return 'claude'
  if (id.startsWith('gpt') || /^o\d/.test(id)) return 'gpt'
  if (id.startsWith('gemini')) return 'gemini'
  if (id.startsWith('grok')) return 'grok'
  return 'other'
}
